import { ListGroup, Badge, Button } from 'react-bootstrap';
import PageFade from '../../components/animation/PageFade';
import { StaggerFade } from '../../components/animation/StaggerFade';

const notifications = [
  { id: 'n1', message: 'Order ORD-1004 requires approval', read: false, createdAt: 'Just now' },
  { id: 'n2', message: 'Low stock on 4K Monitor', read: true, createdAt: '1h ago' },
];

export default function NotificationsPage() {
  return (
    <PageFade>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>Notifications</h3>
        <Button size="sm" variant="outline-primary">
          Mark all as read
        </Button>
      </div>
      <ListGroup>
        <StaggerFade>
          {notifications.map((item) => (
            <ListGroup.Item key={item.id} className="d-flex justify-content-between align-items-center">
              <div>
                {!item.read && (
                  <Badge bg="primary" className="me-2">
                    New
                  </Badge>
                )}
                {item.message}
                <div className="text-muted small">{item.createdAt}</div>
              </div>
              <Button size="sm" variant="light">
                View
              </Button>
            </ListGroup.Item>
          ))}
        </StaggerFade>
      </ListGroup>
    </PageFade>
  );
}

